import { useQuery } from '@tanstack/react-query';
import { Mail, Users } from 'lucide-react';
import WidgetShell from '@/components/admin/dashboard/WidgetShell';
import StatCard from '@/components/admin/dashboard/StatCard';
import api from '@/lib/api';

/**
 * Newsletter reach — active subscribers + recent growth. Wraps
 * GET /admin/newsletter/subscribers/stats (counts come back as strings from
 * postgres.js, so coerce with Number()).
 */
interface SubscriberStats {
  active_count: number | string;
  inactive_count: number | string;
  new_last_7_days: number | string;
  new_last_30_days: number | string;
}

export default function NewsletterSummaryWidget() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['dashboard', 'newsletter'],
    queryFn: () => api.get<SubscriberStats>('/admin/newsletter/subscribers/stats'),
    staleTime: 60000,
  });

  return (
    <WidgetShell
      title="Newsletter"
      icon={<Mail />}
      to="/admin/newsletter/subscribers"
      isLoading={isLoading}
      error={error}
      skeletonClassName="h-24"
    >
      {data && (
        <div className="grid grid-cols-2 gap-3">
          <StatCard
            title="Subscribers"
            value={Number(data.active_count).toLocaleString()}
            icon={<Users />}
            tone="blue"
          />
          <StatCard
            title="New (30 days)"
            value={Number(data.new_last_30_days).toLocaleString()}
            subtitle={`${Number(data.new_last_7_days).toLocaleString()} in last 7 days`}
            icon={<Mail />}
            tone="green"
          />
        </div>
      )}
    </WidgetShell>
  );
}
